import React, { useEffect, useState, useRef } from "react";
import "../../css/custom.css";
import "../../css/style.css";
import { useAuthenticationContext } from "../../../Context/Authentication";
import { useInventoryProductContext } from "../../../Context/Cache/InventoryProductContext";
import { useCartInventoryContext } from "../../../Context/Cache/CartInventoryContext";
import { useAmazonInventoryCacheContext } from "../../../Context/Cache/AmazonInventory/AmazonInventoryCacheContext";
import { useSearchContext } from '../../../Context/SetGlobalSearch';
import { Pagination, ImageViewer } from "../../ExternalComponent";
import AlgopixUI from "../../AtuReplenishment/Atu/AlgopixUI";
import { Link, useLocation } from "react-router-dom"; // Amit
import { toast, ToastContainer } from "react-toastify";
import ExcelJS from 'exceljs';
import { FaFileExport } from "react-icons/fa6";
import newproductImage from '../../Assets/img/newProductImage.png';
import { FaSortUp, FaSortDown } from 'react-icons/fa';
import amazon from "../../Assets/img/algopix/shopping.png";
import ebay from "../../Assets/img/algopix/ebay.png";
import walmart from "../../Assets/img/algopix/walmart.png";
import axios from "axios";

// const columns = [
//   // Amit 02-08-2024
//   { key : "new", label: "", width: "0px", padding: "0px 2px"},
//   { key: "image", label: "Image", width: "80px" },
//   { key: "sku", label: "SKU", width: "80px" },
//   { key: "brand", label: "Brand", width: "100px" },
//   { key: "productName", label: "Product Name", width: "200px" },
//   { key: "color", label: "Color", width: "70px" },
//   { key: "size", label: "Size(with UOM)", width: "70px" },
//   { key: "packaging", label: "Packaging", width: "80px" },
//   { key: "upc", label: "UPC", width: "100px" },
//   { key: "availableQuantity", label: "Available Quantity", width: "70px" },
//   { key: "requestedQuantity", label: "Requested Quantity", width: "100px" },
//   { key: "price", label: "Price", width: "80px" },
//   { key: "msrp", label: "MSRP", width: "80px" },
//   { key: "counterOffer", label: "Offer Price", width: "100px" },
//   { key: "masterCase", label: "Case Pack", width: "80px" },
//   { key: "soldInEU", label: "Sold in EU", width: "70px" },
//   { key: "expirationDate", label: "Expiration date", width: "100px" },
//   { key: "batch", label: "Batch", width: "70px" },
// ];


const AmazonTable = () => {
  const {
    inventoryFilteredProducts,
    counterOffers,
    requestedQuantities,
    handleSelectedRowCheckboxChange,
    setRequestedQuantities,
    setCounterOffers,
    handleButtonClick,
    handleCloseClick,
    showPopup,
    algopixdata,
    amazonData,
    ebayData,
    walmartData,
    exportExcelName, isExpanded, setIsExpanded,
    toggleWidth,
    isSelectAllChecked, setIsSelectAllChecked,
    visibleColumns,
    setVisibleColumns,
    algopixMarketList,
    selectedMarket,
    setSelectedMarket,
    handleMarketChange,
    clearAllMarketFilter,
    applyMarketFilter,
    attributeMapping,
    combinedSelectedItems, isRangeChanged, showApplyFilterOptions,
    appliedSelectedMarket,
    setAppliedSelectedMarket,
    // Amit 23-09-2024
    getFieldValue

    // handleProductCheckboxChange
  } = useAmazonInventoryCacheContext();
  // Amit 17-09-2024
  const [sysMarketColumnList, setSysMarketColumnList] = useState([]);
  const [columns, setColumns] = useState([])
  useEffect(() => {
    console.log("")
    let newcolumn = [
      { key: "new", label: "", width: "0px", padding: "0px 2px" },
      { key: "image", label: "Image", width: "80px" },
      { key: "sku", label: "SKU", width: "80px" },
      { key: "brand", label: "Brand", width: "100px" },
      { key: "productName", label: "Product Name", width: "200px" },
      { key: "color", label: "Color", width: "70px" },
      { key: "size", label: "Size(with UOM)", width: "70px" },
      { key: "packaging", label: "Packaging", width: "80px" },
      { key: "upc", label: "UPC", width: "100px" },
      { key: "availableQuantity", label: "Available Quantity", width: "70px" },
      { key: "requestedQuantity", label: "Requested Quantity", width: "100px" },
      { key: "price", label: "Price", width: "80px" },
      { key: "msrp", label: "MSRP", width: "80px" },
      { key: "counterOffer", label: "Offer Price", width: "100px" },
      { key: "masterCase", label: "Case Pack", width: "80px" },
      { key: "soldInEU", label: "Sold in EU", width: "70px" },
      { key: "expirationDate", label: "Expiration date", width: "100px" },
      { key: "batch", label: "Batch", width: "70px" }
    ];
    let newcolumn2 = [];
    algopixMarketList.forEach((market) => {
      let columnlist = attributeMapping.filter((val) => val.market == market.label);
      columnlist = columnlist.sort((a, b) => a.fieldtype - b.fieldtype);
      if (columnlist[0].columnkey.includes('walmart')) {
        newcolumn.push(
          { key: columnlist[0].columnkey, label: columnlist[0].columnname, width: "120px", color: columnlist[0].color, market: columnlist[0].market },
          { key: columnlist[1].columnkey, label: columnlist[1].columnname, width: "140px", color: columnlist[1].color, market: columnlist[1].market },
          { key: columnlist[2].columnkey, label: columnlist[2].columnname, width: "160px", color: columnlist[2].color, market: columnlist[2].market },
          { key: columnlist[3].columnkey, label: columnlist[3].columnname, width: "150px", color: columnlist[3].color, market: columnlist[3].market },
          { key: columnlist[4].columnkey, label: columnlist[4].columnname, width: "100px", color: columnlist[4].color, market: columnlist[4].market },
          { key: columnlist[5].columnkey, label: columnlist[5].columnname, width: "140px", color: columnlist[5].color, market: columnlist[5].market },
          { key: columnlist[6].columnkey, label: columnlist[6].columnname, width: "180px", color: columnlist[6].color, market: columnlist[5].market }
        )
      } else {
        newcolumn.push(
          { key: columnlist[0].columnkey, label: columnlist[0].columnname, width: "120px", color: columnlist[0].color, market: columnlist[0].market },
          { key: columnlist[1].columnkey, label: columnlist[1].columnname, width: "140px", color: columnlist[1].color, market: columnlist[1].market },
          { key: columnlist[2].columnkey, label: columnlist[2].columnname, width: "160px", color: columnlist[2].color, market: columnlist[2].market },
          { key: columnlist[3].columnkey, label: columnlist[3].columnname, width: "150px", color: columnlist[3].color, market: columnlist[3].market },
          { key: columnlist[4].columnkey, label: columnlist[4].columnname, width: "100px", color: columnlist[4].color, market: columnlist[4].market },
          { key: columnlist[5].columnkey, label: columnlist[5].columnname, width: "140px", color: columnlist[5].color, market: columnlist[5].market },
        )
      }
      newcolumn2.push(columnlist[0]);
      newcolumn2.push(columnlist[1]);
      newcolumn2.push(columnlist[2]);
      newcolumn2.push(columnlist[3]);
      newcolumn2.push(columnlist[4]);
      newcolumn2.push(columnlist[5]);
      if (columnlist[0].columnkey.includes('walmart')) newcolumn2.push(columnlist[6]);

    })
    setColumns(newcolumn);
    console.log("newcolumn2", newcolumn2);
    console.log("visibleColumns", visibleColumns);
    setSysMarketColumnList(newcolumn2);
  }, [attributeMapping, algopixMarketList, visibleColumns])
  // const {fetchAmazonInventoryData} = useAmazonInventoryCacheContext()
  const { handleProductCheckboxChange, setSelectedRows, currentPath,
    setCurrentPath, selectedRows } = useCartInventoryContext();
  const { screenSize } = useAuthenticationContext();

  // const [visibleColumns, setVisibleColumns] = useState(
  //   columns.map((col) => col.key)
  // );

  const [showDropdown, setShowDropdown] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [sortedExcelData, setSortedExcelData] = useState([])
  const [currentRecords, setCurrentRecords] = useState([]);
  const [recordsPerPage, setRecordsPerPage] = useState(100);
  const tableContainerRef = useRef(null);
  const [indexOfLastRecord, setIndexOfLastRecord] = useState(currentPage * recordsPerPage);
  const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(indexOfLastRecord - recordsPerPage);
  // const recordsPerPage = 100;
  const { searchTerm, setSearchResults } = useSearchContext();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    const newFilteredProducts = searchTerm
      ? inventoryFilteredProducts.filter(product =>
        (product.name && product.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (product.nyc_brand && product.nyc_brand.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (product.nyc_upc && product.nyc_upc.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (product.productnumber && product.productnumber.toLowerCase().includes(searchTerm.toLowerCase()))
      )
      : inventoryFilteredProducts;

    setFilteredProducts(newFilteredProducts);
    setSearchResults(newFilteredProducts);
    setCurrentPage(1);
  }, [searchTerm, inventoryFilteredProducts]);

  const [sortConfig, setSortConfig] = useState({ key: 'brand', direction: 'asc' });

  // Amit 23-09-2024
  const columnKeyToRecordField = {
    brand: 'nyc_brand',
    sku: 'productnumber',
    productName: 'name',
    color: 'nyc_color',
    size: 'size',
    packaging: 'nyc_packaging',
    upc: 'nyc_upc',
    availableQuantity: 'strava_availablequantity',
    requestedQuantity: 'requestedQuantity',
    price: 'price',
    msrp: 'nyc_msrp',
    counterOffer: 'counterOffer',
    masterCase: 'nyc_mastercasequantity',
    soldInEU: 'nyc_soldineurope',
    expirationDate: 'strava_expirationdate',
    batch: 'nyc_batchcode',
    amazonaunumberofsellers: 'amazonaunumberofsellers',
    amazonauprice: 'amazonauprice',
    amazonaurank: 'amazonaurank',
    amazonausalespermonth: 'amazonausalespermonth',
    amazonausalespermonthtransaction: 'amazonausalespermonthtransaction',
    amazonauurllisting: 'amazonauurllisting',
    amazonusnumberofsellers: 'amazonusnumberofsellers',
    amazonusprice: 'amazonusprice',
    amazonusrank: 'amazonusrank',
    amazonussalespermonth: 'amazonussalespermonth',
    amazonussalespermonthtransaction: 'amazonussalespermonthtransaction',
    amazonusurllisting: 'amazonusurllisting',
    ebayusnumberofsellers: 'ebayusnumberofsellers',
    ebayusprice: 'ebayusprice',
    ebayusrank: 'ebayusrank',
    ebayussalespermonth: 'ebayussalespermonth',
    ebayussalespermonthtransaction: 'ebayussalespermonthtransaction',
    ebayusurllisting: 'ebayusurllisting',
    walmartusnumberofsellers: 'walmartusnumberofsellers',
    walmartusprice: 'walmartusprice',
    walmartusrank: 'walmartusrank',
    walmartussalespermonth: 'walmartussalespermonth',
    walmartussalespermonthtransaction: 'walmartussalespermonthtransaction',
    walmartusurllisting: 'walmartusurllisting',
    walmartreviewinlastthirtydays: 'walmartreviewinlastthirtydays',
  };


  // Declare isNumeric outside useEffect

  useEffect(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    const isNumeric = (value) => {
      return !isNaN(value) && !isNaN(parseFloat(value));
    };

    const alphanumericSort = (a, b) => {
      if (!sortConfig.key) return 0; // No sorting if no column is selected

      const fieldKey = columnKeyToRecordField[sortConfig.key];

      let valueA = a[fieldKey];
      let valueB = b[fieldKey];

      // Handle cases where value is "-" or "N/A"
      if (valueA === "-" || valueA === "N/A") valueA = valueA === "-" ? -Infinity : null;
      if (valueB === "-" || valueB === "N/A") valueB = valueB === "-" ? -Infinity : null;

      // Convert the values to numbers if they are numeric
      if (isNumeric(valueA) && isNumeric(valueB)) {
        valueA = parseFloat(valueA);
        valueB = parseFloat(valueB);

        // Sort numeric values in descending order by default
        return sortConfig.direction === 'asc' ? valueB - valueA : valueA - valueB;
      }

      // Handling cases where values are "-" (-Infinity) and "N/A" (null)
      if (valueA === -Infinity || valueB === -Infinity || valueA === null || valueB === null) {
        // Ascending order: "-" first, then "N/A"
        if (sortConfig.direction === 'asc') {
          if (valueA === -Infinity) return -1;
          if (valueB === -Infinity) return 1;
          if (valueA === null) return -1;
          if (valueB === null) return 1;
        }
        // Descending order: "N/A" first, then "-"
        else {
          if (valueA === null) return -1;
          if (valueB === null) return 1;
          if (valueA === -Infinity) return 1;
          if (valueB === -Infinity) return -1;
        }
      }

      // If values are not numeric, treat them as strings
      valueA = valueA ? valueA.toString().toLowerCase() : '';
      valueB = valueB ? valueB.toString().toLowerCase() : '';

      // Regex to split numbers and non-numbers for alphanumeric sorting
      const regex = /(\d+|\D+)/g;

      const aParts = valueA.match(regex) || [];
      const bParts = valueB.match(regex) || [];

      for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
        const aPart = aParts[i];
        const bPart = bParts[i];

        // If both parts are numbers, compare them numerically
        if (!isNaN(aPart) && !isNaN(bPart)) {
          const diff = parseInt(aPart) - parseInt(bPart);
          if (diff !== 0) return sortConfig.direction === 'asc' ? diff : -diff;
        } else {
          // If parts are not numbers, compare them as strings
          if (aPart !== bPart) return sortConfig.direction === 'asc' ? aPart.localeCompare(bPart) : bPart.localeCompare(aPart);
        }
      }

      // If all parts are equal so far, compare by length of the split arrays
      return sortConfig.direction === 'asc' ? aParts.length - bParts.length : bParts.length - aParts.length;
    };


    // Sort products using the updated alphanumeric and numeric sort function
    const sortedFilteredProducts = [...filteredProducts].sort(alphanumericSort);

    // Other logic...
    setSortedExcelData(sortedFilteredProducts);
    setCurrentRecords(sortedFilteredProducts.slice(indexOfFirstRecord, indexOfLastRecord));

  }, [filteredProducts, currentPage, recordsPerPage, sortConfig]);

  const nPages = Math.ceil(filteredProducts.length / recordsPerPage);

  const toggleColumnVisibility = (key) => {
    setVisibleColumns((prevState) =>
      prevState.includes(key)
        ? prevState.filter((col) => col !== key)
        : [...prevState, key]
    );
  };

  const toggleAllColumns = () => {
    let newcolumn = columns.filter((item) => checkForMarketColumn(item));
    console.log("visibleColumns", visibleColumns);
    console.log("newcolumn", newcolumn);
    if (visibleColumns.length === newcolumn.length) {
      setVisibleColumns([]);
    } else {
      let tempcolumn = [...newcolumn];
      tempcolumn = tempcolumn.map((item) => item.key);
      setVisibleColumns(tempcolumn);
    }
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setIsSelectAllChecked(isChecked);
    if (isChecked) {
      setSelectedProducts(filteredProducts);
      setSelectedRows(sortedExcelData);
    } else {
      setSelectedProducts([]);
      setSelectedRows([]);
    }
  };


  const handleProductCheckbox = (product, checked) => {
    setIsSelectAllChecked(false);
    handleProductCheckboxChange(product, checked);
    if (checked) {
      setSelectedProducts(prev => [...prev, product]);
      var isPresent = selectedRows.filter(item => item.nyc_upc === product.nyc_upc);

      if (isPresent.length === 0) {
        setSelectedRows(prev => [...prev, product]);
      }
      else {
        setSelectedRows(prev => prev.map(item => item.nyc_upc === product.nyc_upc ? product : item));
      }
    } else {
      setSelectedProducts(prev => prev.filter(p => p !== product));
      setSelectedRows(prev => prev.filter(p => p !== product));
    }
  };
  let previousError = null;
  const decimalPattern = /^(\d*\.{0,1}\d{0,2}$)/;
  const handleInputChange = (index, field, value) => {
    setCurrentRecords((prevRecords) => {
      const updatedRecords = [...prevRecords];
      const product = { ...updatedRecords[index] };

      if (field === "requestedQuantity") {
        if (value !== "" && (isNaN(value) || value < 0)) {
          product[field] = 0;
          const errorMessage = "Requested Quantity must be a positive number";
          if (errorMessage !== previousError) {
            toast.error(errorMessage);
            previousError = errorMessage;
          }
        } else if (value > parseInt(product.strava_availablequantity)) {
          product[field] = 0;
          const errorMessage =
            "Requested Quantity cannot be more than Available Quantity";
          if (errorMessage !== previousError) {
            toast.error(errorMessage);
            previousError = errorMessage;
          }
        } else {
          product[field] = parseInt(value, 10);
          previousError = null; // Clear previous error on valid input
        }
      } else if (field === "counterOffer") {
        if (value !== "" && (isNaN(value) || !value.match(decimalPattern))) {
          product[field] = 0;
          const errorMessage = "Counter Offer must be a positive number";
          if (errorMessage !== previousError) {
            toast.error(errorMessage);
            previousError = errorMessage;
          }
        } else {
          product[field] = formatCurrency(value);
          previousError = null; // Clear previous error on valid input
        }
      } else {
        if (value !== "" && (isNaN(value) || value <= 0)) {
          product[field] = 0;
          const errorMessage = "Value must be a positive number";
          if (errorMessage !== previousError) {
            toast.error(errorMessage);
            previousError = errorMessage;
          }
        } else {
          product[field] = parseInt(value, 10);
          previousError = null; // Clear previous error on valid input
        }
      }

      updatedRecords[index] = product;
      var isPresent = selectedRows.filter(item => item.nyc_upc === product.nyc_upc && item.productnumber === product.productnumber);

      if (isPresent.length === 0) {
        setSelectedRows(prev => [...prev, product]);
      }
      else {
        setSelectedRows(prev => prev.map(item => item.nyc_upc === product.nyc_upc && item.productnumber === product.productnumber ? product : item));
      }
      return updatedRecords;
    });
  };
  const formatCurrency = (value) => {
    // Remove any non-numeric characters except the decimal point
    value = value.replace(/[^\d.]/g, "");

    // Ensure two decimal places
    const parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas to the integer part

    // Limit to two decimal places
    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].slice(0, 2);
    }

    // Join integer and decimal parts
    value = parts.join(".");

    // Add dollar sign
    return `${value}`;
  };
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  useEffect(() => {
    if (pathnames != currentPath) {
      setIsSelectAllChecked(false)
      setSelectedRows([]);
      setCurrentPath(pathnames);
    }
  }, [])

  function hexToARGB(hex) {
    let hexValue = hex.replace("#", "");

    if (hexValue.length === 3) {
      // Convert shorthand hex (#ABC) to full hex (#AABBCC)
      hexValue = hexValue.split("").map(char => char + char).join("");
    }

    const r = hexValue.substring(0, 2); // Red
    const g = hexValue.substring(2, 4); // Green
    const b = hexValue.substring(4, 6); // Blue

    // Return ARGB with alpha set to FF (full opacity)
    return `FF${r}${g}${b}`.toUpperCase();
  }

  // Amit 26-09-2024
  // Amit 26-09-2024
  const toDataURL = (url, width = 70, height = 70) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        const base64Url = canvas.toDataURL("image/jpeg");
        resolve({ base64Url });
      };
      img.onerror = function () {
        reject(new Error("Failed to load image at " + url));
      };
      img.src = url;
    });
  };

  // const handleExcelExport = async () => {

  //   let newexportExcelName = null;
  //   let marketNameIfOneMarket = "";
  //   let isamazon = 0, isebay = 0, iswalmart = 0;;
  //   const data = selectedRows.map((item) => {
  //     var tempArray = {};

  //     // Adding static columns
  //     if (visibleColumns.includes("image")) tempArray.Image = {
  //       text: 'Image Link',
  //       hyperlink: `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.productnumber || 'placeholder'}.jpg`
  //     };
  //     if (visibleColumns.includes("sku")) tempArray.SKU = item.productnumber;
  //     if (visibleColumns.includes("brand")) tempArray.Brand = item.nyc_brand;
  //     if (visibleColumns.includes("productName")) tempArray["Product Name"] = item.name;
  //     if (visibleColumns.includes("color")) tempArray.Color = item.nyc_color;
  //     if (visibleColumns.includes("size")) tempArray["Size(with UOM)"] = item.size + item.nyc_sizeuom;
  //     if (visibleColumns.includes("packaging")) tempArray.Packaging = item.nyc_packaging;
  //     if (visibleColumns.includes("upc")) tempArray.UPC = item.nyc_upc;
  //     if (visibleColumns.includes("availableQuantity")) tempArray["Available Quantity"] = item.strava_availablequantity;
  //     if (visibleColumns.includes("requestedQuantity")) tempArray["Requested Quantity"] = item.requestedQuantity == undefined ? "-" : item.requestedQuantity;
  //     if (visibleColumns.includes("price")) tempArray.Price = item.price;
  //     if (visibleColumns.includes("msrp")) tempArray.MSRP = item.nyc_msrp;
  //     if (visibleColumns.includes("counterOffer")) tempArray["Offer Price"] = item.counterOffer == undefined ? "-" : item.counterOffer;
  //     if (visibleColumns.includes("masterCase")) tempArray["Case Pack"] = item.nyc_mastercasequantity;
  //     if (visibleColumns.includes("soldInEU")) tempArray["Sold In Europe"] = item.nyc_soldineurope ? "Yes" : "No";
  //     if (visibleColumns.includes("expirationDate")) tempArray.ExpirationDate = item.expirationDate;
  //     if (visibleColumns.includes("batch")) tempArray.Batch = item.nyc_batchcode;

  //     // Algopix Columns (dynamic)

  //     algopixMarketList.forEach((market) => {

  //       let columnlist = attributeMapping.filter((val) => val.market == market.label);
  //       columnlist = columnlist.sort((a, b) => a.fieldtype - b.fieldtype);

  //       // Amit 24-09-2024
  //       columnlist.forEach((col, index) => {
  //         console.log("columnkeyvalue", item?.[col.columnkey]);
  //         if (visibleColumns.includes(col.columnkey)) {
  //           if (col.columnkey.includes('listing')) {
  //             if (col.columnkey.includes('amazon')) isamazon = 1;
  //             if (col.columnkey.includes('ebay')) isebay = 1;
  //             if (col.columnkey.includes('walmart')) iswalmart = 1;
  //             marketNameIfOneMarket = col.columnkey.includes('amazon') ? "(Amazon)" :
  //               col.columnkey.includes('ebay') ? "(eBay)" : "(Walmart)";
  //             tempArray[col.marketbrand + " " + col.columnname] = {
  //               text: ((item?.[col.columnkey] == "-") ? "-" : "Link"),
  //               hyperlink: item?.[col.columnkey] // hyperlink is the URL from the data
  //             };

  //           } else {
  //             tempArray[col.marketbrand + " " + col.columnname] = item?.[col.columnkey];
  //           }

  //         }
  //       });
  //     });

  //     return tempArray;
  //   });

  //   if ((isamazon + isebay + iswalmart) > 1) {
  //     marketNameIfOneMarket = "";
  //     if ((isamazon + isebay + iswalmart) == 3) {
  //       newexportExcelName = "New York Cosmetics Online Inventory File";
  //     }
  //   }

  //   if (data[0] == undefined) {
  //     toast.warning("please select some rows");
  //     return;
  //   }

  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Sheet1');

  //   const headers = Object.keys(data[0]);
  //   worksheet.addRow(headers);

  //   data.forEach((item) => {
  //     const row = worksheet.addRow(Object.values(item));

  //     if (headers.indexOf('Image') != -1) {
  //       const imageCell = row.getCell(headers.indexOf('Image') + 1);
  //       if (imageCell.value && imageCell.value.text === 'Image Link') {
  //         imageCell.font = { color: { argb: '550000FF' }, underline: 'single' };
  //       }
  //     }
  //     // Amit 25-09-2024
  //     if (headers.indexOf('AMAZON US URL Listing') != -1) {
  //       const marketCell = row.getCell(headers.indexOf('AMAZON US URL Listing') + 1);
  //       if (marketCell.value && marketCell.value.text === 'Link') {
  //         marketCell.font = { color: { argb: '550000FF' }, underline: 'single' };
  //       }
  //     }
  //     if (headers.indexOf('EBAY US URL Listing') != -1) {
  //       const marketCell = row.getCell(headers.indexOf('EBAY US URL Listing') + 1);
  //       if (marketCell.value && marketCell.value.text === 'Link') {
  //         marketCell.font = { color: { argb: '550000FF' }, underline: 'single' };
  //       }
  //     }
  //     if (headers.indexOf('WALMART US URL Listing') != -1) {
  //       const marketCell = row.getCell(headers.indexOf('WALMART US URL Listing') + 1);
  //       if (marketCell.value && marketCell.value.text === 'Link') {
  //         marketCell.font = { color: { argb: '550000FF' }, underline: 'single' };
  //       }
  //     }
  //   });

  //   const headerRow = worksheet.getRow(1);
  //   headerRow.height = 40;

  //   // Add colors to Algopix headers based on their market
  //   headerRow.eachCell((cell, colNumber) => {
  //     const headerName = headers[colNumber - 1];
  //     console.log("headerName", headerName);
  //     console.log("attributeMapping", attributeMapping);
  //     const marketColumn = attributeMapping.find(attr => { console.log("attr.columnname == headerName", (attr.columnname == headerName)); return (attr.marketbrand + " " + attr.columnname) == headerName }); // changed here
  //     console.log("marketColumn.color", marketColumn?.color || "no color");
  //     // Amit 26-09-2024

  //     // Apply color if it's a dynamic Algopix column
  //     // if (marketColumn && marketColumn.color) { // changed here
  //     //   console.log("if");
  //     //   cell.fill = {
  //     //     type: 'pattern',
  //     //     pattern: 'solid',
  //     //     fgColor: { argb: hexToARGB(marketColumn.color) } // Set the specific color for that market // changed here
  //     //   };
  //     // } else {
  //     console.log("else");
  //     // Default color for non-Algopix columns
  //     cell.fill = {
  //       type: 'pattern',
  //       pattern: 'solid',
  //       fgColor: { argb: 'FF973131' },
  //       // };
  //     }

  //     cell.border = {
  //       top: { style: 'thin', color: { argb: '000000' } },
  //       left: { style: 'thin', color: { argb: '000000' } },
  //       bottom: { style: 'thin', color: { argb: '000000' } },
  //       right: { style: 'thin', color: { argb: '000000' } },
  //     };
  //     cell.alignment = { vertical: 'middle', horizontal: 'center' };
  //     cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' }, };

  //   }); // changed here

  //   worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
  //     if (rowNumber > 1) {
  //       row.height = 70;
  //       row.eachCell({ includeEmpty: true }, (cell) => {
  //         cell.fill = {
  //           type: 'pattern',
  //           pattern: 'solid',
  //           fgColor: { argb: rowNumber % 2 === 0 ? 'FFFFFFFF' : 'FFFFE7E7' },
  //         };
  //       });
  //     }
  //     row.eachCell({ includeEmpty: true }, (cell) => {
  //       cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  //       cell.border = {
  //         top: { style: 'thin', color: { argb: '000000' } },
  //         left: { style: 'thin', color: { argb: '000000' } },
  //         bottom: { style: 'thin', color: { argb: '000000' } },
  //         right: { style: 'thin', color: { argb: '000000' } },
  //       };
  //     });
  //   });

  //   worksheet.columns.forEach(column => {
  //     let maxLength = 0;
  //     column.eachCell({ includeEmpty: true }, (cell) => {
  //       if (cell.value) {
  //         const cellValue = cell.value.toString();
  //         maxLength = Math.max(maxLength, cellValue.length);
  //       }
  //     });
  //     column.width = Math.min(Math.max(maxLength + 2, 10), 30);
  //   });

  //   const packagingColumnIndex = headers.indexOf('Packaging') + 1;
  //   const column = worksheet.getColumn(packagingColumnIndex);
  //   if (column) {
  //     column.width = 15;
  //   }

  //   const today = new Date();
  //   const pad = (num) => num.toString().padStart(2, '0');
  //   const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;

  //   workbook.xlsx.writeBuffer().then((data) => {
  //     const blob = new Blob([data], {
  //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     const anchor = document.createElement('a');
  //     anchor.href = url;
  //     anchor.download = `${newexportExcelName == null ? "NewYorkCosmetics-ProductList" : newexportExcelName}-${marketNameIfOneMarket}-${formattedDate}.xlsx`;
  //     document.body.appendChild(anchor);
  //     anchor.click();
  //     document.body.removeChild(anchor);
  //     window.URL.revokeObjectURL(url);
  //   });
  // };

  const handleExcelExport = async (email) => {

    if (!visibleColumns.includes("image")) {
      toast.warning("Image column is hidden, please select it to proceed");
      return;
    }

    let newexportExcelName = null;
    let marketNameIfOneMarket = "";
    let isamazon = 0, isebay = 0, iswalmart = 0;

    const data = selectedRows.map((item) => {
      let tempArray = {};

      // Adding static columns
      if (visibleColumns.includes("image")) {
        const imageUrl = `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.productnumber || 'placeholder'}.jpg`;
        tempArray.Image = {
          formula: `_xlfn.IMAGE("${imageUrl}", 1)`,
          result: ""
        };
      }
      // `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.productnumber || 'placeholder'}.jpg`;
      if (visibleColumns.includes("sku")) tempArray.SKU = item.productnumber;
      if (visibleColumns.includes("brand")) tempArray.Brand = item.nyc_brand;
      if (visibleColumns.includes("productName")) tempArray["Product Name"] = item.name;
      if (visibleColumns.includes("color")) tempArray.Color = item.nyc_color;
      if (visibleColumns.includes("size")) tempArray["Size(with UOM)"] = item.size + item.nyc_sizeuom;
      if (visibleColumns.includes("packaging")) tempArray.Packaging = item.nyc_packaging;
      if (visibleColumns.includes("upc")) tempArray.UPC = item.nyc_upc;
      if (visibleColumns.includes("availableQuantity")) tempArray["Available Quantity"] = item.strava_availablequantity;
      if (visibleColumns.includes("requestedQuantity")) tempArray["Requested Quantity"] = item.requestedQuantity || "-";
      if (visibleColumns.includes("price")) tempArray.Price = item.price;
      if (visibleColumns.includes("msrp")) tempArray.MSRP = item.nyc_msrp;
      if (visibleColumns.includes("counterOffer")) tempArray["Offer Price"] = item.counterOffer || "-";
      if (visibleColumns.includes("masterCase")) tempArray["Case Pack"] = item.nyc_mastercasequantity;
      if (visibleColumns.includes("soldInEU")) tempArray["Sold In Europe"] = item.nyc_soldineurope ? "Yes" : "No";
      if (visibleColumns.includes("expirationDate")) tempArray.ExpirationDate = item.expirationDate;
      if (visibleColumns.includes("batch")) tempArray.Batch = item.nyc_batchcode;

      // Handling dynamic columns
      algopixMarketList.forEach((market) => {
        let columnList = attributeMapping
          .filter((val) => val.market === market.label)
          .sort((a, b) => a.fieldtype - b.fieldtype);

        columnList.forEach((col) => {
          if (visibleColumns.includes(col.columnkey)) {
            if (col.columnkey.includes('listing')) {
              if (col.columnkey.includes('amazon')) isamazon = 1;
              if (col.columnkey.includes('ebay')) isebay = 1;
              if (col.columnkey.includes('walmart')) iswalmart = 1;

              marketNameIfOneMarket = col.columnkey.includes('amazon')
                ? "(Amazon)"
                : col.columnkey.includes('ebay')
                  ? "(eBay)"
                  : "(Walmart)";

              tempArray[`${col.marketbrand} ${col.columnname}`] = {
                text: item[col.columnkey] === "-" ? "-" : "Link",
                hyperlink: item[col.columnkey],
              };
            } else {
              tempArray[`${col.marketbrand} ${col.columnname}`] = item[col.columnkey];
            }
          }
        });
      });

      return tempArray;
    });

    if ((isamazon + isebay + iswalmart) > 1) {
      marketNameIfOneMarket = "";
      if ((isamazon + isebay + iswalmart) === 3) {
        newexportExcelName = "New York Cosmetics Online Inventory File";
      }
    }

    if (data.length === 0) {
      toast.warning("Please select some rows.");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);

    data.forEach((item) => {
      const row = worksheet.addRow(Object.values(item));

      if (headers.includes('Image')) {
        const imageCell = row.getCell(headers.indexOf('Image') + 1);
        if (imageCell.value?.text === 'Image Link') {
          imageCell.font = { color: { argb: '550000FF' }, underline: 'single' };
        }
      }
    });

    const headerRow = worksheet.getRow(1);
    headerRow.height = 40;

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF973131' },
      };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
    });

    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      if (rowNumber > 1) {
        row.height = 80;
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            // fgColor: { argb: rowNumber % 2 === 0 ? 'FFFFFFFF' : 'FFFFE7E7' },
            fgColor: 'FFFFFFFF'
          };
        });
      }
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          right: { style: 'thin', color: { argb: 'FFE5E7EB' } },
        };
      });
    });

    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        if (cell.value) {
          const cellValue = cell.value.toString();
          maxLength = Math.max(maxLength, cellValue.length);
        }
      });
      column.width = Math.min(Math.max(maxLength + 2, 10), 30);
    });

    // set Image column width
    const imageColumnIndex = headers.indexOf('Image') + 1;
    const imagecolumn = worksheet.getColumn(imageColumnIndex);
    if (imagecolumn) {
      imagecolumn.width = 12;
    }

    const today = new Date();
    const formattedDate = `${today.getMonth() + 1}.${today.getDate()}.${today.getFullYear()}`;

    const excelName = `${newexportExcelName ?? "NewYorkCosmetics-ProductList"}-${marketNameIfOneMarket}-${formattedDate}.xlsx`;

    // Write the workbook to a buffer and convert to Base64
    const base64Excel = await workbook.xlsx.writeBuffer().then((buffer) => {
      return btoa(
        new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
    });

    console.log("Excel Name:", excelName);
    // console.log( base64Excel); // Store or send this Base64 as needed
    // console.log(email);
    // const payload = {
    //   fileName: excelName,
    //   emailAddress: email,
    //   fileContent: base64Excel
    // };

    const payload = {
      filename: excelName,
      useremail: email,
      filecontent: base64Excel
    };

    toast.success("Preparing your download, please check your email shortly.");

    //console.log("endpoint: "+process.env.REACT_APP_UAT_AZURE_EXPORT_EXCEL_FUNCTION_ENDPOINT);
    axios.post(
      process.env.REACT_APP_SEND_EXPORT_EXCEL,
      payload,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
      .then((response) => {
        console.log(response.data);
        // toast.success("Excel sent to " + email);
      })
      .catch((error) => {
        console.error(error);
      });



  };

  const handleExcelExportWithoutImage = async () => {

    let newexportExcelName = null;
    let marketNameIfOneMarket = "";
    let isamazon = 0, isebay = 0, iswalmart = 0;;
    const data = selectedRows.map((item) => {
      var tempArray = {};

      // Adding static columns

      if (visibleColumns.includes("sku")) tempArray.SKU = item.productnumber;
      if (visibleColumns.includes("brand")) tempArray.Brand = item.nyc_brand;
      if (visibleColumns.includes("productName")) tempArray["Product Name"] = item.name;
      if (visibleColumns.includes("color")) tempArray.Color = item.nyc_color;
      if (visibleColumns.includes("size")) tempArray["Size(with UOM)"] = item.size + item.nyc_sizeuom;
      if (visibleColumns.includes("packaging")) tempArray.Packaging = item.nyc_packaging;
      if (visibleColumns.includes("upc")) tempArray.UPC = item.nyc_upc;
      if (visibleColumns.includes("availableQuantity")) tempArray["Available Quantity"] = item.strava_availablequantity;
      if (visibleColumns.includes("requestedQuantity")) tempArray["Requested Quantity"] = item.requestedQuantity == undefined ? "-" : item.requestedQuantity;
      if (visibleColumns.includes("price")) tempArray.Price = item.price;
      if (visibleColumns.includes("msrp")) tempArray.MSRP = item.nyc_msrp;
      if (visibleColumns.includes("counterOffer")) tempArray["Offer Price"] = item.counterOffer == undefined ? "-" : item.counterOffer;
      if (visibleColumns.includes("masterCase")) tempArray["Case Pack"] = item.nyc_mastercasequantity;
      if (visibleColumns.includes("soldInEU")) tempArray["Sold In Europe"] = item.nyc_soldineurope ? "Yes" : "No";
      if (visibleColumns.includes("expirationDate")) tempArray.ExpirationDate = item.expirationDate;
      if (visibleColumns.includes("batch")) tempArray.Batch = item.nyc_batchcode;

      // Algopix Columns (dynamic)

      algopixMarketList.forEach((market) => {

        let columnlist = attributeMapping.filter((val) => val.market == market.label);
        columnlist = columnlist.sort((a, b) => a.fieldtype - b.fieldtype);

        // Amit 24-09-2024
        columnlist.forEach((col, index) => {
          console.log("columnkeyvalue", item?.[col.columnkey]);
          if (visibleColumns.includes(col.columnkey)) {
            if (col.columnkey.includes('listing')) {
              if (col.columnkey.includes('amazon')) isamazon = 1;
              if (col.columnkey.includes('ebay')) isebay = 1;
              if (col.columnkey.includes('walmart')) iswalmart = 1;
              marketNameIfOneMarket = col.columnkey.includes('amazon') ? "(Amazon)" :
                col.columnkey.includes('ebay') ? "(eBay)" : "(Walmart)";
              tempArray[col.marketbrand + " " + col.columnname] = {
                text: ((item?.[col.columnkey] == "-") ? "-" : "Link"),
                hyperlink: item?.[col.columnkey] // hyperlink is the URL from the data
              };

            } else {
              tempArray[col.marketbrand + " " + col.columnname] = item?.[col.columnkey];
            }

          }
        });
      });

      return tempArray;
    });

    if ((isamazon + isebay + iswalmart) > 1) {
      marketNameIfOneMarket = "";
      if ((isamazon + isebay + iswalmart) == 3) {
        newexportExcelName = "New York Cosmetics Online Inventory File";
      }
    }

    if (data[0] == undefined) {
      toast.warning("please select some rows");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);

    data.forEach((item) => {
      const row = worksheet.addRow(Object.values(item));

      // Amit 25-09-2024
      if (headers.indexOf('AMAZON US URL Listing') != -1) {
        const marketCell = row.getCell(headers.indexOf('AMAZON US URL Listing') + 1);
        if (marketCell.value && marketCell.value.text === 'Link') {
          marketCell.font = { color: { argb: '550000FF' }, underline: 'single' };
        }
      }
      if (headers.indexOf('EBAY US URL Listing') != -1) {
        const marketCell = row.getCell(headers.indexOf('EBAY US URL Listing') + 1);
        if (marketCell.value && marketCell.value.text === 'Link') {
          marketCell.font = { color: { argb: '550000FF' }, underline: 'single' };
        }
      }
      if (headers.indexOf('WALMART US URL Listing') != -1) {
        const marketCell = row.getCell(headers.indexOf('WALMART US URL Listing') + 1);
        if (marketCell.value && marketCell.value.text === 'Link') {
          marketCell.font = { color: { argb: '550000FF' }, underline: 'single' };
        }
      }
    });

    const headerRow = worksheet.getRow(1);
    headerRow.height = 40;

    // Add colors to Algopix headers based on their market
    headerRow.eachCell((cell, colNumber) => {
      const headerName = headers[colNumber - 1];
      console.log("headerName", headerName);
      console.log("attributeMapping", attributeMapping);
      const marketColumn = attributeMapping.find(attr => { console.log("attr.columnname == headerName", (attr.columnname == headerName)); return (attr.marketbrand + " " + attr.columnname) == headerName }); // changed here
      console.log("marketColumn.color", marketColumn?.color || "no color");
      // Amit 26-09-2024

      // Apply color if it's a dynamic Algopix column
      // if (marketColumn && marketColumn.color) { // changed here
      //   console.log("if");
      //   cell.fill = {
      //     type: 'pattern',
      //     pattern: 'solid',
      //     fgColor: { argb: hexToARGB(marketColumn.color) } // Set the specific color for that market // changed here
      //   };
      // } else {
      console.log("else");
      // Default color for non-Algopix columns
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF973131' },
        // };
      }

      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' }, };

    }); // changed here

    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      if (rowNumber > 1) {
        row.height = 70;
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            // fgColor: { argb: rowNumber % 2 === 0 ? 'FFFFFFFF' : 'FFFFE7E7' },
            fgColor: { argb: 'FFFFFFFF' },
          };
        });
      }
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
          right: { style: 'thin', color: { argb: 'FFE5E7EB' } }
        };
      });
    });

    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        if (cell.value) {
          const cellValue = cell.value.toString();
          maxLength = Math.max(maxLength, cellValue.length);
        }
      });
      column.width = Math.min(Math.max(maxLength + 2, 10), 30);
    });

    const packagingColumnIndex = headers.indexOf('Packaging') + 1;
    const column = worksheet.getColumn(packagingColumnIndex);
    if (column) {
      column.width = 15;
    }

    const today = new Date();
    const pad = (num) => num.toString().padStart(2, '0');
    const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `${newexportExcelName == null ? "NewYorkCosmetics-ProductList" : newexportExcelName}-${marketNameIfOneMarket}-${formattedDate}.xlsx`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    });
  };
  /*
    This is to handle Export Excel functionality
    -send selected record with given email to Azure function which
     process excel and send it to provied email
  */
  const [showExportExcelPopup, setShowExportExcelPopup] = useState(false);
  const [exportExcelEmail, setExportExcelEmail] = useState("");
  const [exportExcelError, setExportExcelError] = useState("");
  const [includeImage, setIncludeImage] = useState("Yes");

  // Function to handle "OK" button click
  const handleExportExcelOkClick = () => {
    if (!exportExcelEmail) {
      setExportExcelError("Email is required");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(exportExcelEmail)) {
      setExportExcelError("Invalid email format");
    } else {
      setExportExcelError("");
      handleExcelOpenClosePopup(false)
      console.log("email: " + exportExcelEmail);
      includeImage == "Yes" ? handleExcelExport(exportExcelEmail) : handleExcelExportWithoutImage();
    }
  };

  // Function to close the popup
  const handleExcelOpenClosePopup = (value) => {
    if (value) {
      let email = getEmail();
      console.log("existing user email: " + email);
      if (email != null) {
        setExportExcelEmail(email);
      }
      setShowExportExcelPopup(true);
      setExportExcelError("");
    } else {
      setShowExportExcelPopup(false);
      setExportExcelError("");
    }

  };

  // get Existing user email
  function getEmail() {
    // Step 1: Check if EmailResponse is present in localStorage
    const emailResponse = localStorage.getItem("EmailResponse");

    if (emailResponse) {
      try {
        // Step 2: Parse the JSON string to an object
        const emailResponseObj = JSON.parse(emailResponse);

        // Step 3: Check if email exists in the parsed object
        if (emailResponseObj && emailResponseObj.email) {
          return emailResponseObj.email;
        }
      } catch (error) {
        console.error("Error parsing EmailResponse:", error);
      }
    }

    // Step 4: If no email found in EmailResponse, check NewUserEmail
    const newUserEmail = localStorage.getItem("NewUserEmail");

    if (newUserEmail) {
      return newUserEmail;
    }

    // Step 5: If no email found, return null
    return null;
  };


  useEffect(() => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTop = 0;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    setSelectedProducts([]);
    setSelectedRows([]);
    setIsSelectAllChecked(false); // Reset checkbox state
  };
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl); // Set the selected image URL
    setIsModalOpen(true); // Open the modal
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
    setSelectedImage(null); // Reset the selected image URL
  };
  // AlgoPix code
  // Amit 23-09-2024

  //  function getFieldValue(jsonArrayString, marketBrand, countryCode, fieldtype) {

  //   try{

  //   if(jsonArrayString==null) return "-";
  //   const jsonArray = JSON.parse(jsonArrayString);
  //   if(jsonArray.length==0) return "-";

  //   // Find the object that matches the marketBrand and countryCode
  //   const marketObject = jsonArray.find(obj =>
  //     obj.marketBrand === marketBrand && obj.countryCode === countryCode
  //   );

  //   if (!marketObject) {
  //     return '-';
  //   }

  //   // Get the value based on the fieldtype
  //   switch (fieldtype) {
  //     case 1:
  //       // Price
  //       return (marketObject.offers?.NEW?.marketPrice?.amount ?? '0')+" "+(marketObject.offers?.NEW?.marketPrice?.currencyCode ?? '');

  //     case 2:
  //       // Amit 20-09-2024
  //       //Sales per month in $
  //       return ((marketObject.marketSpecificData?.estimatedSalesRevenues?.amount)+' $' )?? '0';

  //     case 3:
  //       //Sales per month transactions
  //       return marketObject.marketSpecificData?.estimatedUnitSold ?? 'N/A';

  //     case 4:
  //       //URL listing
  //       return marketObject.offers?.NEW?.listingUrl ?? 'N/A';

  //     case 5:
  //       //Rank
  //       const platformName = marketObject.marketBrand.toLowerCase(); // Assuming the platform name is marketBrand
  //       return marketObject.marketSpecificData?.[`${platformName}Categories`]?.[0]?.bestSellerRanking ?? 'N/A';

  //     case 6:
  //       //Number of sellers
  //       return marketObject.marketSpecificData?.competition?.numberOfOffers ?? 'N/A';

  //     default:
  //       return 'Null Value';
  //   }
  // }catch(error){
  //   console.log("error in getFieldValue: "+error);
  // }
  // }

  // Amit 17-09-2024
  // function to check the column associated to any market
  function checkForMarketColumn(column) {
    if (column.key.includes("amazon") || column.key.includes("ebay") || column.key.includes("walmart")) {
      if (appliedSelectedMarket.some((appmarket) => appmarket.key == column.market)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  const [maxHeight, setMaxHeight] = useState(`${screenSize.height - 270}px`);
  useEffect(() => {
    if (combinedSelectedItems.length > 0 || isRangeChanged || selectedMarket.length > 0) {
      if (showApplyFilterOptions == true || selectedMarket.length > 0) {
        setMaxHeight(`${screenSize.height - 300}px`);
      } else {
        setMaxHeight(`${screenSize.height - 235}px`);
      }
    } else {
      setMaxHeight(`${screenSize.height - 280}px`);
    }
  }, [combinedSelectedItems, isRangeChanged, screenSize.height, selectedMarket]);

  return (
    <div className="order-lg-2 min-w-full" style={{ maxWidth: isExpanded ? `${screenSize.width - 80}px` : `${screenSize.width - 345}px` }}>
      {/* Amit Export Excel */}
      <ToastContainer />
      {showExportExcelPopup && (
        <div
          className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-10 "
        >
          <div
            className="bg-white p-8 rounded-lg shadow-lg w-400"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popup
          >


            {/* Image Input */}
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-1">
                Include Image:
              </label>
              <div className="flex items-center space-x-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="includeImage"
                    value="Yes"
                    checked={includeImage === "Yes"}
                    onChange={(e) => setIncludeImage(e.target.value)}
                    className="mr-2"
                  />
                  Yes
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="includeImage"
                    value="No"
                    checked={includeImage === "No"}
                    onChange={(e) => setIncludeImage(e.target.value)}
                    className="mr-2"
                  />
                  No
                </label>
              </div>
            </div>
            {/* Email Input */}
            {includeImage == "Yes" &&
              <>
                <label className="block text-gray-700 font-medium mb-1">Enter Your Email:</label>
                <input
                  type="email"
                  value={exportExcelEmail}
                  onChange={(e) => setExportExcelEmail(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded mb-2"
                  placeholder="example@example.com"
                  required
                />
              </>
            }

            {/* Error Message */}
            {exportExcelError && <p className="text-red-500 mb-4">{exportExcelError}</p>}

            {/* OK Button */}
            <button
              onClick={handleExportExcelOkClick}
              className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600 mr-2"
            >
              OK
            </button>

            {/* Close Button */}
            <button
              onClick={() => setShowExportExcelPopup(false)}
              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
            >
              Close
            </button>
          </div>
        </div>
      )}
      <div className="flex justify-between items-center nycfix-product-space">
        <h6 className="font-bold py-2">Products ({filteredProducts.length})</h6>
        <div className="flex gap-2">
          <button
            className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md"
            onClick={() => handleExcelOpenClosePopup(true)}
          >
            <FaFileExport />
          </button>
          <div
            className="dropdown-container"
            onMouseEnter={() => setShowDropdown(true)}
            onMouseLeave={() => setShowDropdown(false)}
          >
            <button className="dropdown-button flex items-center gap-2 px-2 font-bold py-2 bg-white-600 text-black text-sm rounded-md">
              Hide/Show Column
              {/* <PiColumnsPlusLeftFill  /> */}
            </button>
            {showDropdown && (
              <div
                // Amit 24-09-2024  (Freeze changes)
                style={{ zIndex: 6 }}
                className="dropdown-content flex gap-3">
                <div>
                  <input
                    type="checkbox"
                    className="mr-3"
                    checked={visibleColumns.length === columns.filter((item) => checkForMarketColumn(item)).length}
                    onChange={toggleAllColumns}
                  />
                  Select All
                </div>
                <div>
                  {columns.map((col) => col.key !== "new" && checkForMarketColumn(col) ? (
                    <div className="flex gap-2" key={col.key}>
                      <input
                        type="checkbox"
                        className="mr-3"
                        checked={visibleColumns.includes(col.key)}
                        onChange={() => toggleColumnVisibility(col.key)}
                      />
                      {/* Amit 24-09-2024 */}
                      {col.key.includes('amazon') ? ("Amazon " + col.label) :
                        col.key.includes('ebay') ? ("eBay " + col.label) :
                          col.key.includes('walmart') ? ("Walmart " + col.label) : col.label
                      }
                    </div>
                  ) : <></>)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        ref={tableContainerRef}
        className="table-container box-border shadow-sm background-white max-h-screen overflow-auto nycfix-table-container"
        //  Amit 24-09-2024  ( Horizontal scrollbar)
        // style={{ maxHeight: `${screenSize.height - 250}px` }}
        style={{ maxHeight: maxHeight }}
      >
        <table className="table-fixed min-w-full"
          //  Amit 24-09-2024 (Freeze changes)
          style={{ position: "relative", borderCollapse: 'collapse' }}
        >

          <thead
            // Amit 24-09-2024  (Freeze changes)
            style={{ zIndex: 5 }}
          >
            <tr>
              <th className="w-10"
                // Amit 24-09-2024 (Freeze changes)
                style={{
                  position: 'sticky',
                  left: 0,
                  backgroundColor: '#eee',
                  zIndex: 2, // Ensure it's above other columns
                  width: '50px', // Define a fixed width for the checkbox column
                }}
              >
                <input
                  type="checkbox"
                  id="selectAllProducts"
                  checked={isSelectAllChecked}
                  onChange={handleSelectAllChange}
                />
              </th>
              {columns.map(col => {
                const marketcode = col.key.includes('ebay') ? 1 : 0;
                const imageurl = col.key.includes('amazon') ? amazon :
                  col.key.includes('ebay') ? ebay : col.key.includes('walmart') ? walmart : null;
                return (visibleColumns.includes(col.key) && (
                  <th
                    key={col.key}

                    style={{
                      width: col.width,
                      padding: col.padding,
                      backgroundColor: "#eee",
                      ...(col.key.includes('image') && {
                        position: 'sticky',
                        left: 50,
                        zIndex: 2, // Ensure it's above other columns
                      })
                    }}
                    onClick={col.key !== 'image' ? () => handleSort(col.key) : undefined}
                    className={col.key !== 'image' ? "cursor-pointer" : ""}
                  >
                    {/* {imageurl?<img className={`h-4 inline ${marketcode === 1 ? 'w-8' : 'w-4'}`} src={imageurl}></img>:""}  {col.label} {sortConfig.key === col.key ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''} */}
                    <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      {imageurl ? (
                        <div>
                          <img className={`h-4 ${marketcode === 1 ? 'w-6' : 'w-4'}`} src={imageurl} />
                        </div>
                      ) : (
                        ""
                      )}

                      <div style={{ display: 'flex' }}>
                        <p class="text-[13px]">{col.label}</p>
                        <p class="text-[13px]">{sortConfig.key === col.key ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}</p>
                      </div>
                    </div>
                  </th>
                ))
              })}
            </tr>
          </thead>
          <tbody >
            {currentRecords.map((product, index) => (
              <tr
                key={index}
                className={"bg-white"}
                style={{ borderBottom: "1px solid #E5E7EB" }}
              >
                {/* Amit 24-09-2024 (Freeze changes) */}
                <td
                  style={{
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#fff', // Ensure it doesn’t overlap other columns
                    zIndex: 2, // Ensure it's above other columns
                    width: '50px', // Define a fixed width for the checkbox column
                  }}
                >
                  <input
                    type="checkbox"
                    onChange={(e) => handleProductCheckbox(product, e.target.checked)}
                    checked={selectedRows.some(obj => obj.nyc_upc === product.nyc_upc && obj.productnumber === product.productnumber)}
                  />
                </td>
                <td style={{ position: "absolute", width: "40px", left: "21px" }}
                >
                  {product.nyc_receivedinlast30days === true ? <img src={newproductImage} /> : <></>}
                </td>
                {/* {visibleColumns.includes("image") && (
                  <td className="cursor-pointer"
                    // Amit 24-09-2024 (Freeze changes)
                    style={{
                      position: 'sticky',
                      backgroundColor: '#fff', // Ensure it doesn’t overlap other columns
                      left: 50,
                      zIndex: 2, // Ensure it's above other columns
                    }}
                  >
                    <img
                      src={`https://nycdatastorage.blob.core.windows.net/compressproduct-uatcontain/${product.productnumber}.jpg`}
                      alt="Product"
                      className="w-16 h-16 object-cover"
                      style={{ padding: "5px 0px" }}
                      onClick={() =>
                        handleImageClick(
                          `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${product.productnumber}.jpg`
                        )
                      } // Pass image URL on click
                    />
                  </td>
                )} */}
                {visibleColumns.includes("image") && (
                  <td className="cursor-pointer" style={{ backgroundColor: "white" }}>
                      <div className="flex items-center justify-center" style={{ width: "64px", height: "64px", overflow: "hidden", backgroundColor: "white" }}>
                        <img
                          src={`https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${product.productnumber}.jpg`}
                          alt="Product"
                          className="max-w-full max-h-full object-contain"
                          loading="lazy"
                          style={{
                             maxWidth: "100%",
                             maxHeight: "100%",
                             objectFit: "contain", 
                             display: "block",
                             cursor: "pointer"
                          }}
                          onClick={() =>
                            handleImageClick(
                              `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${product.productnumber}.jpg`
                            )
                          }
                        />
                      </div>
                  </td>
                )}

                {visibleColumns.includes("sku") && (
                  <td className="text-[#DC0A0A]" style={{ fontWeight: 700 }}>{product.productnumber}</td>
                )}

                {visibleColumns.includes("brand") && (
                  <td>{product.nyc_brand}</td>
                )}

                {visibleColumns.includes("productName") && (
                  <td className="productName">{product.name}</td>
                )}

                {visibleColumns.includes("color") && (
                  <td>{product.nyc_color}</td>
                )}

                {visibleColumns.includes("size") && <td>{product.size}{" "}{product.nyc_sizeuom}</td>}

                {visibleColumns.includes("packaging") && (
                  <td>{product.nyc_packaging}</td>
                )}

                {visibleColumns.includes("upc") && (
                  <td>
                    <span
                      className="cursor-pointer"
                      title="Click to view Insights"
                    // onClick={() => handleButtonClick(product.nyc_upc)}
                    >
                      {product.nyc_upc}
                    </span>
                  </td>
                )}
                {visibleColumns.includes("availableQuantity") && (
                  <td>{product.strava_availablequantity}</td>
                )}

                {visibleColumns.includes("requestedQuantity") && (
                  <td>
                    <input
                      type="text"
                      value={product.requestedQuantity || ""}
                      onChange={(e) => handleInputChange(index, "requestedQuantity", e.target.value)}
                      className="width50"
                    />
                  </td>
                )}

                {visibleColumns.includes("price") && <td>{product["price@OData.Community.Display.V1.FormattedValue"]}</td>}

                {visibleColumns.includes("msrp") && <td>{product["nyc_msrp@OData.Community.Display.V1.FormattedValue"]}</td>}

                {visibleColumns.includes("counterOffer") && (
                  <td>
                    <input
                      type="text"
                      value={product.counterOffer || ""}
                      onChange={(e) => handleInputChange(index, "counterOffer", e.target.value)}
                      className="width50"
                    />
                  </td>
                )}

                {visibleColumns.includes("masterCase") && (
                  <td>{product.nyc_mastercasequantity}</td>
                )}
                {visibleColumns.includes("soldInEU") && (
                  <td>{product.nyc_soldineurope ? "Yes" : "No"}</td>
                )}
                {visibleColumns.includes("expirationDate") && (
                  <td>{product.strava_expirationdate}</td>
                )}
                {visibleColumns.includes("batch") && (
                  <td>{product.nyc_batchcode}</td>
                )}
                {/* Amit 23-09-2024 */}
                {sysMarketColumnList.map((value, key) => {

                  return (
                    visibleColumns.includes(value.columnkey) && (value.columnkey.includes("urllisting") ?
                      <td>
                        {(product?.[value.columnkey] != "-" && product?.[value.columnkey] != "N/A") ?
                          <a class="text-blue-500 underline" target="_blank" href={product?.[value.columnkey]}>Link</a>
                          : <p>-</p>
                        }
                      </td>
                      : <td>{((value.fieldtype == 1 || value.fieldtype == 2) && product?.[value.columnkey] != '-') ? "$" : ""}{product?.[value.columnkey]}</td>
                    )
                  )

                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* AlgopixUi */}

      {showPopup && (
        <AlgopixUI
          handleClose={handleCloseClick}
          algopixdata={algopixdata}
          amazonData={amazonData}
          ebayData={ebayData}
          walmartData={walmartData}
        />
      )}

      {/* AlgopixUi change */}
      <div className="pagination-container">
        <Pagination
          nPages={nPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
      {/* Image Ui change */}
      {isModalOpen && selectedImage && (
        <div className="fixed z-10 inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-4 rounded relative w-auto max-w-full">
            {/* Render the ImageViewer component */}
            <ImageViewer imageUrl={selectedImage} onClose={handleCloseModal} />
          </div>
        </div>
      )}
    </div>
  );
}

export default AmazonTable